import React, { useState, useEffect } from "react";
import { Button, Row } from "react-bootstrap";
import chevronRight from "../../../../assets/images/chevron-right.png";
import deletes from "../../../../assets/images/delete.png";
import "../utils/index.css";
import {  getPaymentMethodByCountry } from "../../business/services/developerApi";
import { Color } from "antd/es/color-picker";
import { addCommissionBusiness, getAllMerchentCom, getCommissionBusiness, getCommissionCountry, getPaymentMethod, getPaymentMethodBusiness, updateCommissionBusiness, updateCommissionCountry } from "../services/commissionApi";
import { useQuery } from "react-query";
import { getBusinessMarchandById } from "../../merchant/services/merchentApi";
import defaultAvatar from "../../../../assets/images/default-avatar.png";
import Securite from "../component/securite";
import Paiement from "../component/paiement";
import Notification from "../component/notification";
import JournalActivite from "../component/journalActivite";
import { Modal, Spin, Switch } from "antd";
import SimulerChangementBusinessModal from "../component/SimulerChangementBusinessModal";
import toast from "react-hot-toast";
import SimulerChangementCountryModal from "../component/SimulerChangementMarchandModal";
import { getCountryMethods } from "../../../transactions/services/transactionApi";
import Utilisateurs from "../../parametre-user/pages";
import { CreditCardOutlined } from "@ant-design/icons";
import DeveloperAccount from "../component/tabBusiness";
const Commissions = () => {
  //commissions defaut business 
const [selectedCommission, setSelectedCommission] = useState(null);
   const [showDetailModal, setShowDetailModal] = useState(false);
      const [showDetailModalCB, setShowDetailModalCB] = useState(false);
      const [modalContext, setModalContext] = useState(null);
      const [modalContextCB, setModalContextCB] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
     const [isModalOpenCB, setIsModalOpenCB] = useState(false);
     const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
     const [editingCommission, setEditingCommission] = useState(null);
     // const { data: countries, isLoading: isLoadingCountry, isError: isErrorCountry } = useQuery("countries", getCountryMethods);
  const [countries, setCountries] = useState([ 
    { name: "Sénégal", country: "SN", commissionPercentage: "" },
    { name: "Côte d'Ivoire", country: "CI", commissionPercentage: "" },
    { name: "Burkina Faso", country: "BF", commissionPercentage: "" },
    { name: "Bénin", country: "BJ", commissionPercentage: "" },
    { name: "Niger", country: "NE", commissionPercentage: "" },
    { name: "Mali", country: "ML", commissionPercentage: "" },
    { name: "Guinée", country: "GN", commissionPercentage: "" },
    { name: "Togo", country: "TG", commissionPercentage: "" },
    { name: "Cameroun", country: "CM", commissionPercentage: "" },
    { name: "RDC", country: "CD", commissionPercentage: "" },
    { name: "Kenya", country: "KE", commissionPercentage: "" },
    { name: "Nigeria", country: "NG", commissionPercentage: "" },
    { name: "Ghana", country: "GH", commissionPercentage: "" }]);
    const countryFlags = {
  SN: "https://flagcdn.com/w40/sn.png", // Sénégal
  CI: "https://flagcdn.com/w40/ci.png", // Côte d'Ivoire
  BF: "https://flagcdn.com/w40/bf.png", // Burkina Faso
  BJ: "https://flagcdn.com/w40/bj.png", // Bénin
  NE: "https://flagcdn.com/w40/ne.png", // Niger
  ML: "https://flagcdn.com/w40/ml.png", // Mali
  GN: "https://flagcdn.com/w40/gn.png", // Guinée
  TG: "https://flagcdn.com/w40/tg.png", // Togo
  CM: "https://flagcdn.com/w40/cm.png", // Cameroun
  CD: "https://flagcdn.com/w40/cd.png" , // RDC
  KE: "https://flagcdn.com/w40/ke.png", // KE
  NG: "https://flagcdn.com/w40/ng.png",  // ng
  GH: "https://flagcdn.com/w40/gh.png"//gh
};

const countryNames = {
  SN: "Sénégal",
  CI: "Côte d'Ivoire",
  BF: "Burkina Faso",
  BJ: "Bénin",
  NE: "Niger",
  ML: "Mali",
  GN: "Guinée",
  TG: "Togo",
  CM: "Cameroun",
  CD: "RDC",
  KE:"Kenya",
  NG:"Nigerai",
  GH:"Ghana"
};
const [loadingIndex, setLoadingIndex] = useState(null);
const getDisplayedCommission = (countryCode, method, type) => {
  const key =
    type === "payin" ? "payInCommission" : "payOutCommission";

  // 1️⃣ Valeur en cours d’édition (state local)
  const localMethod =
    paymentMethodsByCountry[countryCode]?.find(
      m => (m.id || m.name) === (method.id || method.name)
    );

  if (localMethod?.[key] !== undefined) {
    return localMethod[key];
  }

  // 2️⃣ Valeur sauvegardée (si encore utilisée)
  const countryCommission = commissions?.find(
    c => c.country === countryCode
  );

  const savedMethod = countryCommission?.paymentMethods?.find(
    pm =>
      pm.paymentMethod?.toUpperCase() ===
      (method.id || method.name)?.toUpperCase()
  );

  if (savedMethod?.[key] !== undefined) {
    return savedMethod[key];
  }

  // 3️⃣ Valeur par défaut backend
  return method?.[key] ?? 0;
};

const handleSaveOneLine = async (countryCode, updatedMethod) => {
  try {
    const methodId = updatedMethod.id || updatedMethod.name;

    const payIn = Number(updatedMethod.payInCommission) || 0;
    const payOut = Number(updatedMethod.payOutCommission) || 0;

    await updateCommissionCountry({
      id: methodId,
      payInCommission: payIn,
      payOutCommission: payOut,
    });

    // 🔄 Mise à jour locale (MÊMES CLÉS QUE L’API)
    setCommissions(prev => {
      const countryExists = prev.find(c => c.country === countryCode);

      if (countryExists) {
        const updatedMethods = countryExists.paymentMethods.map(pm =>
          (pm.paymentMethod || pm.name) === methodId
            ? {
                ...pm,
                payInCommission: payIn,
                payOutCommission: payOut,
              }
            : pm
        );

        if (!updatedMethods.find(pm => (pm.paymentMethod || pm.name) === methodId)) {
          updatedMethods.push({
            paymentMethod: methodId,
            payInCommission: payIn,
            payOutCommission: payOut,
          });
        }

        return prev.map(c =>
          c.country === countryCode
            ? { ...c, paymentMethods: updatedMethods }
            : c
        );
      }

      return [
        ...prev,
        {
          country: countryCode,
          paymentMethods: [
            {
              paymentMethod: methodId,
              payInCommission: payIn,
              payOutCommission: payOut,
            },
          ],
        },
      ];
    });

    toast.success("Commission sauvegardée avec succès !");
    setEditingCountry(null);
    setEditingMethod(null);
  } catch (error) {
    console.error("❌ Erreur API:", error);
    toast.error("❌ Erreur lors de la sauvegarde !");
  }
};


const [commissionsBusiness, setCommissionsBusiness] = useState({}); // ⬅️ objet, pas tableau
const [loadingCommissionBusiness, setLoadingCommissionBusiness] = useState(null);

const fetchBusinessCommissions = async (businessId) => {
  try {
    setLoadingCommissionBusiness(businessId);

    const commissions = await getCommissionBusiness(businessId) ;
setCommissionsBusiness((prev) => ({
  ...prev,
  [businessId]: commissions
}));


  } catch (error) {
    console.error("❌ Erreur récupération commissions business:", error);
  }
};
const handleSaveOneLineBusiness = async (businessId, countryCode, updatedMethod) => {
  try {
    const payload = {
      countryCode,
      paymentMethod: updatedMethod.paymentMethod,
      payinCommissionPercentage:
        updatedMethod.paymentMethod === "CARD"
          ? 0
          : Number(updatedMethod.payinCommissionPercentage) ?? 0,
      payoutCommissionPercentage:
        updatedMethod.paymentMethod === "CARD"
          ? 0
          : Number(updatedMethod.payoutCommissionPercentage) ?? 0,
      cardCommissionPercentage:
        updatedMethod.paymentMethod === "CARD"
          ? Number(updatedMethod.cardCommissionPercentage) ?? 0
          : undefined,
    };

    const commissionsForBusiness = commissionsBusiness[businessId] || [];

    let countryData = commissionsForBusiness.find((c) => c.country === countryCode);
    if (!countryData) {
      countryData = { country: countryCode, paymentMethods: [] };
      commissionsForBusiness.push(countryData);
    }

    const existingMethod = countryData.paymentMethods.find(
      (pm) =>
        (pm.paymentMethod || "").trim().toUpperCase() ===
        (payload.paymentMethod || "").trim().toUpperCase()
    );

    if (existingMethod) {
      await updateCommissionBusiness({ businessId, ...payload });
    } else {
      await addCommissionBusiness({ businessId, ...payload });
    }

    toast.success("Commission sauvegardée !");

    // Mise à jour locale
    setCommissionsBusiness((prev) => {
      const businessComms = prev[businessId] || [];
      const countryIndex = businessComms.findIndex((c) => c.country === countryCode);

      if (countryIndex >= 0) {
        const countryData = businessComms[countryIndex];
        const pmIndex = countryData.paymentMethods.findIndex(
          (pm) => pm.paymentMethod === payload.paymentMethod
        );
        if (pmIndex >= 0) {
          countryData.paymentMethods[pmIndex] = { ...payload };
        } else {
          countryData.paymentMethods.push({ ...payload });
        }
        businessComms[countryIndex] = countryData;
      } else {
        businessComms.push({ country: countryCode, paymentMethods: [{ ...payload }] });
      }

      return { ...prev, [businessId]: businessComms };
    });

    setEditingCountryCB(null);
    setEditingMethodCB(null);
  } catch (error) {
    console.error("❌ Erreur API:", error.response?.data || error.message);
    toast.error("❌ Erreur lors de la sauvegarde !");
  }
};
const [isOpen, setIsOpen] = useState(false);
const [isOpenN, setIsOpenN] = useState(false);
const [isOpenP, setIsOpenP] = useState(false);
const [isOpenS, setIsOpenS] = useState(false);
const [isOpenJA, setIsOpenJA] = useState(false);
const [paymentMethodsByCountry, setPaymentMethodsByCountry] = useState({});
const handleStatusChange = (checked, countryCode, index) => {
    const newStatus = checked ? "ACTIVE" : "!ACTIVE";

    setPaymentMethodsByCountry((prev) => {
      const updated = { ...prev };
      const methods = [...(updated[countryCode] || [])];
      if (methods[index]) {
        methods[index] = {
          ...methods[index],
          status: newStatus,
        };
      }
      updated[countryCode] = methods;
      return updated;
    });

    console.log(`🔄 Méthode ${countryCode} index ${index} → ${newStatus}`);
  };

useEffect(() => {
  const fetchAllPaymentMethods = async () => {
    for (const c of countries) {
      try {
        const methods = await getPaymentMethodByCountry(c.country);
        setPaymentMethodsByCountry((prev) => ({
          ...prev,
          [c.country]: methods || []
        }));
      } catch (error) {
        console.error(`❌ Erreur chargement méthodes pour ${c.country}:`, error);
        setPaymentMethodsByCountry((prev) => ({
          ...prev,
          [c.country]: []
        }));
      }
    }
  };
  fetchAllPaymentMethods();
}, [countries]);
  const toggleOpen = () => {
    setIsOpen((prev) => !prev);
  };
   const toggleOpenJA = () => {
    setIsOpenJA((prev) => !prev);
  };
  const toggleOpenN = () => {
    setIsOpenN((prev) => !prev);
  };
   const toggleOpenP = () => {
    setIsOpenP((prev) => !prev);
  };
    const toggleOpenS = () => {
    setIsOpenS((prev) => !prev);
  };
    const [activeTab, setActiveTab] = useState("Commissions");
    const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
    const [openIndex, setOpenIndex] = useState(null);
    const[openIndexE,setOpenIndexE]= useState(null);
     const toggleOpenI = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
   const toggleOpenE = (index) => {
    setOpenIndexE(openIndexE === index ? null : index);
  }; 
  const [editingCountry, setEditingCountry] = useState(null);
  const [editingMethod, setEditingMethod] = useState(null);
    const [editingMethodCB, setEditingMethodCB] = useState(null);
  const [editingCountryCB, setEditingCountryCB] = useState(null);
const [selectedBusinessId, setSelectedBusinessId] = useState(null); 
  const {
    data: allMerchants,
    isLoading: isLoadingAll,
    isError: isErrorAll,
    error: errorAll,
  } = useQuery("developers", getAllMerchentCom, {
  });
  const tabs = ["Taux par pays", "Taux par marchand"];
     const [activeTab1, setActiveTab1] = useState("Taux par pays");
      const handleTabChange = (tab1) => {
      setActiveTab1(tab1);
    };
    const [commissions, setCommissions] = useState([]);
    const [loadingCommission, setLoadingCommission] = useState(null);
  useEffect(() => {
  const fetchCommissions = async () => {
    try {
      setLoadingCommission(true);
      const data = await getCommissionCountry();
      setCommissions(data || []);
    } catch (error) {
      console.error("Erreur récupération commissions:", error);
    }
  };
  fetchCommissions();
}, []);
  const [openIndexB, setOpenIndexB] = useState(null);
  const [merchantBusiness, setBusinessByMerchant] = useState({});
console.log('bbb',merchantBusiness)
const toggleOpenB = async (index, merchantId) => {
  if (!merchantId) {
    console.warn("⚠️ Aucun ID trouvé pour ce marchand !");
    return;
  }

  // fermer si déjà ouvert
  if (openIndexB === index) {
    setOpenIndexB(null);
    return;
  }

  setOpenIndexB(index);

  // si pas encore chargé → activer loader
  if (!merchantBusiness[merchantId]) {
    setLoadingBusiness((prev) => ({
      ...prev,
      [merchantId]: true,
    }));

    try {
      const response = await getBusinessMarchandById(merchantId);
      console.log("API business =", response.data || response);

      setBusinessByMerchant((prev) => ({
        ...prev,
        [merchantId]: response.data || response,
      }));
    } catch (error) {
      console.error("❌ Erreur lors de la récupération des business :", error);

      setBusinessByMerchant((prev) => ({
        ...prev,
        [merchantId]: [],
      }));
    } finally {
      // 🔥 arrêter le loader
      setLoadingBusiness((prev) => ({
        ...prev,
        [merchantId]: false,
      }));
    }
  }
};
const handleApply = (newCommissionData) => {
  console.log("✅ Nouvelle commission appliquée :", newCommissionData);
  setCommissionsBusiness((prev) =>
    prev.map((item) =>
      item.country === newCommissionData.country &&
      item.method.id === newCommissionData.method.id
        ? newCommissionData
        : item
    )
  );
  setShowDetailModalCB(false);
};
const handleApplyC = (newCommissionData) => {
  setCommissions((prev) =>
    prev.map((item) =>
      item.country === newCommissionData.country &&
      item.method.id === newCommissionData.method.id
        ? newCommissionData
        : item
    )
  );
  setShowDetailModal(false);
};
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth <= 768);
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);
  const [defaultPaymentMethods, setDefaultPaymentMethods] = useState({});
useEffect(() => {
  const fetchAllDefaults = async () => {
    const allMethodIds = [];
    (allMerchants ||[]).forEach(merchant => {
      (merchantBusiness?.[merchant.id] || []).forEach(method => {
        method.countryPaymentMethods?.forEach(country => {
          console.log("BUSINESS =", method);
console.log("COUNTRY PAYMENT =", method.countryPaymentMethods);
          country.paymentMethods?.forEach(m => {
            if (!allMethodIds.includes(m.id)) allMethodIds.push(m.id);
          });
        });
      });
    });
    await Promise.all(
      allMethodIds.map(async (id) => {
        if (!defaultPaymentMethods[id]) {
          try {
            const res = await getPaymentMethod(id);
            setDefaultPaymentMethods(prev => ({ ...prev, [id]: res.data??res }));
          } catch (err) {
            console.warn(`Méthode ${id} non trouvée, ignorée.`);
          }
        }
      })
    );
  };
  fetchAllDefaults();
}, [allMerchants, merchantBusiness]);
const [searchTerm, setSearchTerm] = useState("");
const filteredMerchants = Array.isArray(allMerchants)
  ? allMerchants.filter((merchant) => {
      const fullName = `${merchant.firstName} ${merchant.lastName}`.toLowerCase();
      return fullName.includes(searchTerm.toLowerCase());
    })
  : [];
const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 10;
const totalPages = Math.ceil(filteredMerchants.length / itemsPerPage) || 1;
const startIndex = (currentPage - 1) * itemsPerPage;
const currentMerchants = filteredMerchants.slice(startIndex, startIndex + itemsPerPage);
const [loadingBusiness, setLoadingBusiness] = useState({});
  return (
    <Row className="">
     <div className="d-flex flex-column align-items-start gap-3 w-100" style={{ padding: "0 20px" }}>
  <div className="title-page mb-2" style={{ fontSize: "22px", fontWeight: "600", fontFamily: "Poppins" }}>
    Paramètres
  </div>

  <div
    style={{
      display: "flex",
      flexWrap: "wrap",           
      justifyContent: "flex-start", 
      alignItems: "center",
      gap: "16px",                 
      marginTop: "10px",
      marginBottom: "5px",
      width: "100%",
    }}
  >
    {["Commissions","Paiement","Sécurité", "Notifications","Gestion des rôles","Journal d’activité"
    ].map(
      (tab) => (
        <div
          key={tab}
          onClick={() => handleTabClick(tab)}
          style={{
            cursor: "pointer",
            color: activeTab === tab ? "#3761FF" : "#00000073",
            fontWeight: 400,
            fontSize: "16px",
            fontFamily: "Poppins",
            fontStyle: "normal",
            position: "relative",
            paddingBottom: "6px",
            transition: "color 0.3s ease",
          }}
        >
          {tab}
          {activeTab === tab && (
            <div
              style={{
                height: "3px",
                backgroundColor: "#3761FF",
                width: "100%",
                position: "absolute",
                bottom: 0,
                left: 0,
                borderRadius: "2px",
              }}
            />
          )}
        </div>
      )
    )}
  </div>
</div>    
    <div className="">
    {activeTab === "Commissions" && (
    <>
    <div
      style={{
        justifyContent: "start",
        alignItems: "start",
        display: "flex",
        flexDirection: "row",
      
      }}
    >
      <div
       style={{ 
         backgroundColor: "#F5F5F5",
        padding: "5px 5px",
        display: "flex",
      justifyContent: "center",
    
      borderRadius: "100px",                            
                                                                
          }}         
      >
  {tabs.map((tab1) => (
  <div
    key={tab1}
    onClick={() => handleTabChange(tab1)}
    className={` ${activeTab1 === tab1 ? "active" : ""}`} 
    style={{
      backgroundColor: activeTab1 === tab1 ? "#396AFC" : "#F5F5F5",
      color: activeTab1 === tab1 ? "#FFFFFF" : "#141414",
      padding: "5px 20px",
      fontFamily: "Poppins",
      display: "flex",
      justifyContent: "center",
      textAlign: "center",
      fontWeight: 400,
      fontSize: "14px",
      fontStyle: "Medium",
      borderRadius: "100px",
      cursor: "pointer",
    }}
  >
    {tab1}
  </div>
  ))}
      </div>
      </div>
      <Row>
       {activeTab1 === "Taux par pays" && (
          <>
          <div className="mt-3 px-3">
        <div
        style={{
          padding: "20px",
          backgroundColor: "#FFFFFF",
          border: "1px solid #0000001A",
          borderRadius: "8px",
          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
          marginTop: "10px",
          width: "100%",
          margin: "0 auto",
          boxSizing: "border-box" ,
           padding: "10px",
        }}
        >
      <span  style={{
      display: "block",
      width: "100%",
      fontFamily: "Poppins",
      fontSize: "20px",
      fontWeight: "500",
      color: "#070707",
      marginBottom: "20px"
       }}>
            Taux de commission par pays
          </span>
          
        {countries.map((country, index) => (
          <div
            key={index}
            className="mb-3"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                backgroundColor: "#FFFFFF",
                border: "1px solid #0000001A",
                height: "40px",
                overflow: "hidden",
                padding: "0 8px",
                gap: "8px",
                cursor: "pointer",
              }}
              onClick={() => toggleOpenI(index)}
            >
              <img
                 src={countryFlags[country.country] || "/default-flag.png"}
                alt="flag"
                style={{ width: "22px", height: "22px", objectFit: "contain" }}
              />
              <span
                style={{
                  flex: "1",
                  fontFamily: "Poppins",
                  fontSize: "15px",
                  fontWeight: "400",
                  color: "#000000",
                }}
              >
              {country.name || countryNames[country.country] || country.country}
              </span>
              <img
                src={chevronRight}
                alt="chevron"
                style={{
                  width: "22px",
                  height: "22px",
                  transform:
                    openIndex === index ? "rotate(90deg)" : "rotate(0deg)",
                  transition: "transform 0.2s ease",
                }}
              />
            </div>
           {openIndex === index && (
            <div className="responsive-table-wrapper"
          style={{
            marginBottom: "12px",
            padding: "6px 8px",
            backgroundColor: "#fff",
            border: "1px solid #e0e0e0",
            width: "100%",
          }}
        >
      {paymentMethodsByCountry[country.country]?.length > 0 ? (
        <ul style={{ paddingLeft: 0, listStyleType: "none" }}>
          {paymentMethodsByCountry[country.country].map((m, i) => {
          const commissionFromPayIn =
            commissions.find((c) => c.country === country.country)?.paymentMethods.find(
              (pm) => pm.paymentMethod === m.id || pm.paymentMethod === m.name
            )?.payinCommissionPercentage || "";
            const commissionFromPayOut =
            commissions.find((c) => c.country === country.country)?.paymentMethods.find(
              (pm) => pm.paymentMethod === m.id || pm.paymentMethod === m.name
            )?.payoutCommissionPercentage || "";
          return (
            <li className="commission-item"
              key={i}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <Switch
                  checked={m.status === "ACTIVE"}
                  onChange={(checked) => handleStatusChange(checked, country.country, i)}
                  style={{ transform: "scale(0.8)" }}
                />
                <img
                  src={m?.urlLogo || "/default-logo.png"}
                  alt={m?.name}
                  style={{
                    width: "31px",
                    height: "31px",
                    marginRight: "10px",
                    objectFit: "contain",
                    borderRadius: "50%",
                  }}
                />
                <span
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "14px",
                    color: "#333",
                  }}
                >
                  {m?.name}
                </span>
              </div>
              <div
              className="commission-inputs-wrapper"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "20px",
                  marginLeft: "auto",
                }}
              >
<div className="commission-input" style={{ display: "flex", alignItems: "center", gap: "6px" }}>
  <label
    style={{
      fontFamily: "Poppins",
      fontSize: "15px",
      fontWeight: "400",
      color: "#2A2A2A",
      minWidth: "55px",
    }}
  >
    PayIn :
  </label>
<input
  type="number"
  value={getDisplayedCommission(country.country, m, "payin")}
  onChange={(e) => {
    const value = Number(e.target.value);

    setPaymentMethodsByCountry(prev => {
      const list = [...(prev[country.country] || [])];
      const index = list.findIndex(
        pm => (pm.id || pm.name) === (m.id || m.name)
      );

      if (index !== -1) {
        list[index] = { ...list[index], payInCommission: value };
      } else {
        list.push({
          id: m.id,
          payInCommission: value,
          payOutCommission: m.payOutCommission ?? 0,
        });
      }

      return { ...prev, [country.country]: list };
    });
  }}
  disabled={
    !(
      editingCountry === country.country &&
      editingMethod === (m.id || m.name)
    )
  }
  className="form-control"
/>
 <span>
  {country.name === "Ghana" ? "GHS" : "%"}
</span>

</div>
<div className="commission-input" style={{ display: "flex", alignItems: "center", gap: "6px" }}>
  <label
    style={{
      fontFamily: "Poppins",
      fontSize: "15px",
      fontWeight: "400",
      color: "#2A2A2A",
      minWidth: "55px",
    }}
  >
    PayOut :
  </label>
 <input
  type="number"
  value={getDisplayedCommission(country.country, m, "payout")}
  onChange={(e) => {
    const value = Number(e.target.value);

    setPaymentMethodsByCountry(prev => {
      const list = [...(prev[country.country] || [])];
      const index = list.findIndex(
        pm => (pm.id || pm.name) === (m.id || m.name)
      );

      if (index !== -1) {
        list[index] = { ...list[index], payOutCommission: value };
      } else {
        list.push({
          id: m.id,
          payInCommission: m.payInCommission ?? 0,
          payOutCommission: value,
        });
      }

      return { ...prev, [country.country]: list };
    });
  }}
  disabled={
    !(
      editingCountry === country.country &&
      editingMethod === (m.id || m.name)
    )
  }
  className="form-control"
/>


<span>
  {country.name === "Ghana" ? "GHS" : "%"}
</span>

</div>
<button
  type="button"
  className="btn btn-primary "
    loading={loadingCommission}
  onClick={() => handleSaveOneLine(country.country, m)}
  disabled={!(editingCountry === country.country && editingMethod === (m.id || m.name))}
>
  Enregistrer
</button>              
  <div className="more-info"
  onClick={(e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    e.stopPropagation();
    setModalContext({ country: country.country, method: m, index: i }); 
    setIsModalOpen(true);
    setModalPosition({ top: rect.bottom + window.scrollY, left: rect.left + window.scrollX - 100 });
  }}
  style={{
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
    backgroundColor: "#FFFFFF",
    borderRadius: "50%",
    cursor: "pointer",
    border: "1px solid #00000014",
  }}
>
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="6" r="2" fill="#21272A" />
    <circle cx="12" cy="12" r="2" fill="#21272A" />
    <circle cx="12" cy="18" r="2" fill="#21272A" />
  </svg>
</div>        
</div>
  </li>
 );
})}
 </ul>
 ) : (
<div style={{ fontStyle: "italic", color: "#888" }}> Aucune méthode disponible</div>
)}
</div>
)}
 </div>
))}
          </div>
        </div>
  </>
  )}
   {activeTab1 === "Taux par marchand" && (
    <>
    <div className="mt-3 px-3">
      <div style={{ position: "relative", width: "100%" }}></div>
    </div>
  { (
<div
  style={{
    backgroundColor: "#FFFFFF",
    border: "1px solid #0000001A",
    borderRadius: "8px",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
    padding: "10px",
   
    width: "calc(100% - 40px)", 
    marginLeft: "20px",
    marginRight: "20px", 
  
    boxSizing: "border-box",
  }}
>
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "20px",
    }}
  >
    <span
      style={{
        backgroundColor: "#FFFFFF",
        fontFamily: "Poppins",
        fontSize: "20px",
        fontWeight: "500",
        color: "#070707",
      }}
    >
      Taux de commission par marchand
    </span>
  </div>
  <div className="col-12 mb-3">
   <input
  type="text"
  placeholder="Rechercher un marchand..."
  className="form-control search"
  style={{ marginBottom: "10px", fontFamily: "Poppins" }}
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
/>
  </div>
    {currentMerchants?.map((merchant, mIndex) => (
      <div
        key={mIndex}
        className="mb-3"
        style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
        >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          backgroundColor: "#FFFFFF",
          border: "1px solid #0000001A",
          borderRadius: "4px",
          height: "40px",
          overflow: "hidden",
          padding: "0 8px",
          gap: "8px",
        }}
        onClick={() => toggleOpenB(mIndex,merchant.id)}
      >
        <span
          style={{
            flex: "1",
            fontFamily: "Poppins",
            fontSize: "15px",
            fontWeight: "400",
            color: "#000000",
          }}
        >
          {merchant?.firstName} {merchant?.lastName}
        </span>
        <div
          style={{ fontSize: "18px", marginLeft: "8px", cursor: "pointer" }}
        >
           <img
                src={chevronRight}
                alt="chevron"
                style={{
                  width: "17px",
                  height: "17px",
                  transform:
                    openIndexB === mIndex ? "rotate(90deg)" : "rotate(0deg)",
                  transition: "transform 0.2s ease",
                }}
              />
        </div>
      </div>
      {openIndexB === mIndex && (
        <div style={{ width: "100%", }}>
            <div
              style={{
                    display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between", 
                  marginBottom: "12px",
                  padding: "6px 8px",
                  backgroundColor: "#fff",
                  borderRadius: "6px",
                  border: "1px solid #e0e0e0",
                  width: "100%",
                  flexDirection:"column",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              > 
              {loadingBusiness[merchant.id] ? (
  <div style={{ padding: 20 }}>
    <Spin />
  </div>
) : (merchantBusiness?.[merchant.id] || []).length > 0 ? (
  (merchantBusiness?.[merchant.id] || [])
  .filter(Boolean)
  .map((method, bIndex) => (
      <div key={bIndex} style={{ width: "100%", display: "flex", flexDirection: "column", gap: "5px" }}>
          <div
          style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          backgroundColor: "#FFFFFF",
          border: "1px solid #0000001A",
          height: "40px",
          overflow: "hidden",
          padding: "0 8px",
          gap: "8px",
          cursor: "pointer"
        }}
        onClick={async () => {
          setOpenIndexE(openIndexE === bIndex ? null : bIndex);
          if (openIndexE !== bIndex) {
            await fetchBusinessCommissions(method.id);
          }
        }}
      >
        <img
          src={method?.logo || defaultAvatar}
          alt=""
          style={{ width: 29, height: 29, borderRadius: "50%", objectFit: "cover" }}
        />
        <span style={{ flex: 1, fontFamily: "Poppins", fontSize: "15px", fontWeight: "400", color: "#000" }}>
          {method?.businessName}
        </span>
        <span style={{ fontSize: "20px" }}>
          {openIndexE === bIndex ? "-" : "+"}
        </span>
      </div>
      {openIndexE === bIndex && (
        <div className="responsive-table-wrapper"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "10px",
            marginBottom: "12px",
            padding: "6px 8px",
            backgroundColor: "#fff",
            border: "1px solid #e0e0e0",
            width: "100%",
          }}
        >
  <DeveloperAccount
  method={method}
  countryFlags={countryFlags}
  countryNames={countryNames}
  commissionsBusiness={commissionsBusiness}
  paymentMethodsByCountry={paymentMethodsByCountry}
  setPaymentMethodsByCountry={setPaymentMethodsByCountry}
  editingCountryCB={editingCountryCB}
  setEditingCountryCB={setEditingCountryCB}
  editingMethodCB={editingMethodCB}
  setEditingMethodCB={setEditingMethodCB}
  defaultPaymentMethods={defaultPaymentMethods}
  loadingCommissionBusiness={loadingCommissionBusiness}
  handleSaveOneLineBusiness={handleSaveOneLineBusiness}
  setModalContextCB={setModalContextCB}
  setIsModalOpenCB={setIsModalOpenCB}
  setModalPosition={setModalPosition}
/>
  </div>
  )}
  </div>
  ))
) : (
  // ❌ VIDE
  <p style={{ fontSize: "13px", color: "#888" }}>
    Aucun business trouvé pour ce marchand.
  </p>
)}
  </div>
        
    </div>
      )}
    </div>
  ))
  }
 {currentMerchants && currentMerchants.length > 0 ? (
  <div className="d-flex align-items-center gap-2 justify-content-end">

    {/* Bouton précédent */}
    <Button
      style={{ justifyContent: 'center', display: "flex", alignItems: "center", width: "27px", height: "27px" }}
      disabled={currentPage === 1}
      onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
    >
      &laquo;
    </Button>

    {(() => {
      const maxPages = 5;

      let start = Math.max(currentPage - Math.floor(maxPages / 2), 1);
      let end = start + maxPages - 1;

      if (end > totalPages) {
        end = totalPages;
        start = Math.max(end - maxPages + 1, 1);
      }

      return Array.from({ length: end - start + 1 }, (_, i) => start + i).map((page) => (
        <Button
          key={page}
          onClick={() => setCurrentPage(page)}
          style={{
            backgroundColor: currentPage === page ? "#396AFC" : "#F3F3F3",
            color: currentPage === page ? "#FFFFFF" : "#000000",
            border: "1px solid #E3E3E3",
            fontWeight: 500,
            fontSize: "15px",
            fontFamily: 'Inter',
            width: "27px",
            height: "27px",
            justifyContent: 'center',
            display: "flex",
            alignItems: "center"
          }}
        >
          {page}
        </Button>
      ));
    })()}

    {/* Bouton suivant */}
    <Button
      style={{ justifyContent: 'center', display: "flex", alignItems: "center", width: "27px", height: "27px" }}
      disabled={currentPage === totalPages}
      onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
    >
      &raquo;
    </Button>

  </div>
) : (
  <p style={{ fontSize: "13px", color: "#888" }}>
    Aucun marchand trouvé dans cette liste.
  </p>
)}

</div> 
  )}
  
  </>
  )}
   </Row>
    </>
    )}
      {activeTab === "Gestion des rôles" && (
        <> 
         <Utilisateurs
        />
          </>
          )}
    {activeTab === "Sécurité" && (
        <> 
         <Securite
          
        />
          </>
          )}
      {activeTab === "Paiement" && (
        <> 
         <Paiement
          
        />
    </>
    )}
    {activeTab === "Notifications" && (
        <> 
         <Notification
          isOpenN={isOpenN}
          toggleOpenN={toggleOpenN}
          chevronRight={chevronRight}
        />
     </>
     )}
    {activeTab === "Journal d’activité" && (
        <> 
         <JournalActivite
          isOpenN={isOpenJA}
          toggleOpenJA={toggleOpenJA}
          chevronRight={chevronRight}
        />
      </>
    )}
  </div>
{showDetailModal && selectedCommission && (
  <SimulerChangementCountryModal
    show={showDetailModal}
    onClose={() => setShowDetailModal(false)}
    commission={selectedCommission}
    commissions={commissions}
    onApply={handleApplyC} 
  />
)}
{showDetailModalCB && selectedCommission && (
  <SimulerChangementBusinessModal
    show={showDetailModalCB}
    onClose={() => setShowDetailModalCB(false)}
    commission={selectedCommission}              
    commissionsBusiness={commissionsBusiness}   
    onApply={handleApply}                    
  />
)}
<Modal
  open={isModalOpen}
  onCancel={() => setIsModalOpen(false)}
  footer={null}
  width={180}
  style={{
    background: "#FFFFFF",
    position: "absolute",
    top: modalPosition.top,
    left: modalPosition.left,
    borderRadius: 10,
    border: "1px solid #DFDFDF",
    padding: 0,
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
  }}
  bodyStyle={{ padding: "8px 1px" }}
  mask={false}
  closable={false}
>
  <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "12px" }}>
    
    <a
      onClick={() => {
        if (!modalContext) return;
        setEditingCountry(modalContext.country);
        setEditingMethod(modalContext.method.id || modalContext.method.name);
        setIsModalOpen(false);
      }}
      style={{ display: "flex", alignItems: "start", gap: "8px", cursor: "pointer" }}
    >
      <span className="actions">Modifier</span>
    </a>
    <a
      onClick={() => {
        if (!modalContext) return; 
        setSelectedCommission(modalContext); 
        setIsModalOpen(false);              
        setShowDetailModal(true);   
      }}
      style={{ display: "flex", alignItems: "start", gap: "8px", cursor: "pointer" }}
    >
      <span className="actions">Simuler modification</span>
    </a>

  </div>
</Modal>
  <Modal
  open={isModalOpenCB}
  onCancel={() => setIsModalOpenCB(false)}
  footer={null}
  width={180}
  style={{
    background: "#FFFFFF",
    position: "absolute",
    top: modalPosition.top,
    left: modalPosition.left,
    borderRadius: 10,
    border: "1px solid #DFDFDF",
    padding: 0,
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
  }}
  bodyStyle={{ padding: "8px 1px" }}
  mask={false}
  closable={false}
>
  <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "12px" }}>
    <a
  onClick={() => {
    if (!modalContextCB) return;

    const { country, method } = modalContextCB;

    setEditingCountryCB(country);
    setEditingMethodCB(method.id || method.name);

    // Si la commission n’existe pas encore, initialise les valeurs à 0
    setPaymentMethodsByCountry(prev => ({
      ...prev,
      [country]: prev[country] || [],
      [country]: prev[country]?.map(pm => pm) || [{ 
        paymentMethod: method.id || method.name, 
        payinCommissionPercentage: 0, 
        payoutCommissionPercentage: 0 
      }]
    }));

    setIsModalOpenCB(false);
  }}
  style={{ display: "flex", alignItems: "start", gap: "8px", cursor: "pointer" }}
>
  <span className="actions">Modifier</span> 
</a>
    <a
      onClick={() => {
        if (!modalContextCB) return; 
        setSelectedCommission(modalContextCB); 
        setIsModalOpenCB(false);              
        setShowDetailModalCB(true);           
      }}
      style={{ display: "flex", alignItems: "start", gap: "8px", cursor: "pointer" }}
    >
      <span className="actions">Simuler modification</span>
    </a>

  </div>
</Modal>
</Row>
  );
};

export default Commissions;
